import { createSuspenseQuery } from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

export const ViewTasksSchema = z.array(
  z.object({
    id: z.number(),
    display_name: z.string().nullable(),
    description: z.string().nullish(),
    budget_id: z.number().nullish(),
    budget_number: z.string().nullish(),
    location: z.number().nullable().optional(),
    location_id: z.number().nullable().optional(),
    // address: z.string().nullish(),
    color: z.string().nullish(),
    // category: z.string().nullish(),
    // status: z.string().nullish(),
    // tag: z.array(z.string().nullish()),
    // client: z.number().nullish(),
    style: z.string().nullish(),
    // order: z.number(),
    // team: z.string().nullish(),
    // budget: z.number().nullish(),
    // aging: z.string().nullish(),
    // schedule_state: z.string(),
    // contact_state: z.string(),
    // checklist_state: z.string(),
    // companycam_state: z.string(),
    // reminder_state: z.string(),
    _group_value: z.union([z.string(), z.number()]).nullish(),
    _group_count: z.number().nullish()
    // _group_field: z.string().nullish()
  })
);

// Add discriminated union for wf and public requests
const wfRequest = z.object({
  api: z.literal("wf"),
  id: z.string()
});

const publicRequest = z.object({
  api: z.literal("public"),
  slug: z.string(),
  id: z.string()
});

const ViewTasksRequestSchema = z.discriminatedUnion("api", [
  wfRequest,
  publicRequest
]);

const ViewTasksRequestVariables = z.union([
  wfRequest.omit({ api: true }),
  publicRequest.omit({ api: true })
]);

export type ViewTasksRequest = z.infer<typeof ViewTasksRequestSchema>;
export type ViewTasksResponse = z.infer<typeof ViewTasksSchema>;

// URL mappings for wf and public APIs
const urls = {
  wf: "/views/:id/tasks",
  public: "/public/:slug/boardviews/:id/tasks"
};

export const useViewTasksSuspense = createSuspenseQuery<
  ViewTasksResponse,
  ViewTasksRequest,
  Error
>({
  queryKey: ["ViewTasks"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    const { api: viewTasksAPI, ...rest } = variables;
    return api<Omit<ViewTasksRequest, "api">, ViewTasksResponse>({
      method: "GET",
      url: urls[viewTasksAPI],
      requestSchema: ViewTasksRequestVariables,
      responseSchema: ViewTasksSchema,
      body: rest
    });
  }
});
